import { workspaceFeatureService } from "../services/workspaceFeatureService";
import { useAsyncData } from "./useAsyncData";

export function useWorkspaceFeatures(tenantId?: string | null) {
  return useAsyncData(
    () =>
      tenantId
        ? workspaceFeatureService.getAvailability(tenantId)
        : Promise.reject(new Error("No workspace selected.")),
    [tenantId],
  );
}
